import { render, staticRenderFns } from "./AdvListingUsedTag.vue?vue&type=template&id=3b814560&scoped=true"
import script from "./AdvListingUsedTag.vue?vue&type=script&lang=js"
export * from "./AdvListingUsedTag.vue?vue&type=script&lang=js"
import style0 from "./AdvListingUsedTag.vue?vue&type=style&index=0&id=3b814560&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b814560",
  null
  
)

export default component.exports